import React from "react";
import ReactApexChart from "react-apexcharts";
import moment from "moment";
import close from "../../minimise_button.png";
class GradientChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        chart: {
          height: 1000,

          type: "line",
          toolbar: {
            autoSelected: "pan",
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
              
              customIcons: [
                {
                  icon: `<img src=${close} width="20" height="20"> `,
                  index: 0,
                  title: "minimize",
                  class: "custom-icon",
                  click: props.toggleVisibleGraphPanel,
                },
              ],
             
            },
          },
        },

     annotations: {
       
          yaxis: [
            {
              axisTicks:{
                show:true,
              },
              axisBorder: {
                show:true,
                color:'#008FFB',

              },
              title:{
                text: "Discharge",
                style:{
                  color:'#008FFB',
                },
                tooltip: {
                  enabled:true
                }
              }
              },
              {
                seriesName: "Water level",
                oppostite: true,
                min:0,
                max:200,
                axisTicks: {
                    show: true
                },
                axisBorder: {
                    show: true,
                    color: '#00E396',
                },
                labels:{
                  style:{
                    colors:'#00E396',
                  }
                },
                title:{
                  text:"Water level",
                  style:{
                    color:'#00E396',
                  }
                
                }
              },
             
            
              {    
              y: props.station_height,
              borderColor: "#FF0000",
              strokeDashArray:20,
              opacity: 1,
              label: {
                //   borderColor: '#00E396',
                style: {
                  color: "#fff",
                  background: "#385eff",
                },
                text: `Highest Flood Discharge ${props.station_height} cumecs`,
              },
            },
          ],
          xaxis: [
            {
              x: new Date(
                moment(props.curr_date, "DD-MM-YYYY").format("DD MMM YYYY")
              ).getTime(),
              strokeDashArray: 0,
              //   borderColor: '#775DD0',
              label: {
                //   borderColor: '#775DD0',
                style: {
                  color: "#fff",
                  background: "#6b91ff",
                },
                text: "Forecast Date",
              },
            },
          ],
        },

        //dataLabels: {
         // enabled: true,
        // },
        
        
        //DROPDOWN TAB INFLOW-WATER LEVEL-VOLUME-FORECASTING-RAINFALL
        Dropdown: [
          {
            value: '1',
            label: 'Inflow',
            index: 0,
         
            title: 'Inflow',
           // class: 'custom-icon',
            click: props.toggleVisibleGraphPanel,
          },
          {
            value: '2',
            label: 'Volume',
            index: 0,
            title: 'Volume',
            //class: 'custom-icon',
            click: props.toggleVisibleGraphPanel,
          },
        ],

        // IT ENDS HERE

        stroke: {
          width: 2,
        
            curve: 'straight'
          //  lineCap:"butt"
        },

        xaxis: {
          //type: "datetime",
          //format:'dd MMM yyyy HH:mm:ss',
          categories: this.props.categories,
          // labels: {
          //   formatter: function (value, timestamp) {
          //     //console.log(value)
          //     return new Date(timestamp).add(30,'m')
          //   },
          //   // rotate: 0

          // },
          // labels: {
          //   /**
          //   * Allows users to apply a custom formatter function to xaxis labels.
          //   *
          //   * @param { String } value - The default value generated
          //   * @param { Number } timestamp - In a datetime series, this is the raw timestamp
          //   * @param { index } index of the tick / currently executing iteration in xaxis labels array
          //   */
          //   formatter: function(value, timestamp, index) {
          //     return moment(new Date(timestamp)).format("DD MMM YYYY")
          //   }
          // },
          labels: {
            datetimeFormatter: {
              // year: "yyyy",
              // month: "MMM 'yy",
              day: "dd MMM yyyy ",
              hour: "HH:mm:ss",
            },
          },
          tooltip: {
            enabled: false,
          },
        },

        tooltip: {
          theme: "dark",
          type: "datetime",
          x: {
            format: "dd MMM yyyy HH:00:00",
          },
        },

        title: {
          text: props.charttitle,

          align: "center",
          style: {
            fontSize: "16px",
            //color changd from blue to red-1 June 2023
            color: "#FF0000",
            fontSytle: "bold",
            // borderColor:"#FF00FF"
          },
        },

        fill: {
          type: "gradient",
          opacity: 0.2,
          gradient: {
            shadeIntensity: 0.2,
            opacityFrom: 0.1,
            opacityTo: 0.4,
            colorStops: [
              {
                offset: 0,
                color: "#0000ff",
                opacity: 1,
              },
              {
                offset: 60,
                color: "#0000ff",
                opacity: 1,
              },
              {
                offset: 60,
                color: "#FF0000",
                opacity: 1,
              },
              {
                offset: 100,
                color: "#FF0000",
                opacity: 1,
              },
              // {
              //   offset: 0,
              //   color: "#546E7A",
              //   opacity: 1
              // },
              // {
              //   offset: 0,
              //   color: "#66DA26",
              //   opacity: 1
              // },
            ],
          },
        },
        // legend: {
        //   position: 'top',
        //   horizontalAlign: 'right',
        //   floating: true,
        //   offsetY: -25,
        //   offsetX: -5
        // },

        markers: {
          size: 3,
          colors: ["#FFA41B"],
          strokeColors: "#fff",
          strokeWidth: 2,
          hover: {
            size: 7,
          },
        },
        yaxis: {
          min: -100,
          forceNiceScale: true,
          // tickAmount:Number(this.props.station_height) / 5,
          max: props.station_height + 3000,
          // labels:{
          //   formatter:function(val)
          //   {
          //     return(val.toFixed())
          //   }
          // },
          title: {
            text: "Discharge (cumecs)",
            style: {
              fontSize: "14px",
              // color: '#666'
            },
          },
        },
      },
    };
  }

  render() {
    //console.log(this.props);


    let series = [
      {
        name: "Discharge",
        type: 'line',
        data: this.props.data[0],
      },
      {
        
          name: "Water level",
          data: this.props.data[1],
        },
      

    ];
  //console.log("---------------------------------------------------------------")
  //console.log(series)
    return (
      <div>
      <select>
        <option value="1">Inflow</option>
        <option value="2">Volume</option>

      </select>
      <ReactApexChart
        options={this.state.options}
        series={series}
        height="200%"

        type="line"
      />
      </div>
  );
}
}
export default GradientChart;
